import { render, staticRenderFns } from "./cell_status.vue?vue&type=template&id=8ed96cc4&scoped=true&"
import script from "./cell_status.vue?vue&type=script&lang=js&"
export * from "./cell_status.vue?vue&type=script&lang=js&"
import style0 from "./cell_status.vue?vue&type=style&index=0&id=8ed96cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed96cc4",
  null
  
)

export default component.exports